<svg width="100%" height="100%" viewBox="0 0 40 68" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M5 4.02344L32 34.0234L5 64.0234" stroke="url(#paint0_linear_915_5078)" stroke-width="10.9044"/>
    <defs>
        <linearGradient id="paint0_linear_915_5078" x1="5" y1="4.02344" x2="-21.2894" y2="56.1385" gradientUnits="userSpaceOnUse">
            <stop class="gradient__brand"/>
            <stop offset="1" class="gradient__brand-secondary"/>
        </linearGradient>
    </defs>
</svg>
